// ═══════════════════════════════════════════════════════════════
// XYQAR — Exec routes (SPEC SITE 5)
// Auth: TOTP MFA required (loginWithMfa)
// ═══════════════════════════════════════════════════════════════
import { createBrowserRouter, Navigate } from 'react-router-dom';
import PortalShell from './components/PortalShell';
import ExecPortal       from './pages/ExecPortal';
import ContractsList    from './pages/ContractsList';
import ContractDraft    from './pages/ContractDraft';
import ContractReview   from './pages/ContractReview';
import ContractSign     from './pages/ContractSign';
import Invoices         from './pages/Invoices';
import AccountingFEC    from './pages/AccountingFEC';
import Devis            from './pages/Devis';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: PortalShell,
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: 'dashboard',                Component: ExecPortal },
      { path: 'devis',                    Component: Devis },
      { path: 'contracts',                Component: ContractsList },
      { path: 'contracts/draft',          Component: ContractDraft },
      { path: 'contracts/:id/review',     Component: ContractReview },
      { path: 'contracts/:id/sign',       Component: ContractSign },
      { path: 'invoices',                 Component: Invoices },
      { path: 'accounting/fec',           Component: AccountingFEC },
      { path: '*',                        element: <Navigate to="/dashboard" replace /> },
    ],
  },
]);
